import { appConstants } from "../../constants/appconstants";
import { postApiCall } from "../../utils/ApiMethods";


const FetchCompassMainAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/main-page-data`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_COMPASS_CARD_VIEW_ACTION' }, data);
        dispatch(resData);
    }
}

const FetchCompassDetailAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/kpi-page-data`, postData);
        // console.log("data", data);

        var resData = Object.assign({ type: 'SUCCESS_COMPASS_DETAIL_VIEW_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchCompasskpiPageHeaderAction = (requestObj) => {
    return async function (dispatch) {
            dispatch({ type: 'LOADING_COMPASS_KPI_PAGE_HEADER_ACTION' });
            try {
                    const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/kpi-page-header-v2`, requestObj);
                    var resData = Object.assign({ type: 'SUCCESS_COMPASS_KPI_PAGE_HEADER_ACTION' , data } );
                    dispatch(resData);

            } catch (error) {
                dispatch({ type: 'ERROR_COMPASS_KPI_PAGE_HEADER_ACTION', error });
            }
    };
}

// const FetchCompasskpiPageHeaderAction = (postData) => {
//     return async function (dispatch) {
//         const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/kpi-page-header-v2`, postData);
//         // console.log("data", data);

//         var resData = Object.assign({ type: 'SUCCESS_COMPASS_KPI_PAGE_HEADER_ACTION' }, data);
//         dispatch(resData);
//     };
// };

const FetchCompassSectorBuChartAction = (requestObj) => {
    return async function (dispatch) {
            dispatch({ type: 'LOADING_COMPASS_SECTOR_BU_CHART_ACTION' });
            try {
                    const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/sector-bu-chart-v2`, requestObj);
                    var resData = Object.assign({ type: 'SUCCESS_COMPASS_SECTOR_BU_CHART_ACTION' , data } );
                    dispatch(resData);

            } catch (error) {
                dispatch({ type: 'ERROR_COMPASS_SECTOR_BU_CHART_ACTION', error });
            }
    };
}


// const FetchCompassSectorBuChartAction = (postData) => {
//     return async function (dispatch) {
//         const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/sector-bu-chart-v2`, postData);
//         // console.log("data", data);

//         var resData = Object.assign({ type: 'SUCCESS_COMPASS_SECTOR_BU_CHART_ACTION' }, data);
//         dispatch(resData);
//     };
// };

const FetchCompassSectorCategoryChartAction = (requestObj) => {
    return async function (dispatch) {
            dispatch({ type: 'LOADING_COMPASS_SECTOR_CATEGORY_CHART_ACTION' });
            try {
                    const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/sector-category-chart-v2`, requestObj);
                    var resData = Object.assign({ type: 'SUCCESS_COMPASS_SECTOR_CATEGORY_CHART_ACTION' , data } );
                    dispatch(resData);

            } catch (error) {
                dispatch({ type: 'ERROR_COMPASS_SECTOR_CATEGORY_CHART_ACTION', error });
            }
    };
}

// const FetchCompassSectorCategoryChartAction = (postData) => {
//     return async function (dispatch) {
//         const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/sector-category-chart-v2`, postData);
//         // console.log("data", data);

//         var resData = Object.assign({ type: 'SUCCESS_COMPASS_SECTOR_CATEGORY_CHART_ACTION' }, data);
//         dispatch(resData);
//     };
// };

const FetchCompassCoverageReportChartAction = (requestObj) => {
    return async function (dispatch) {
            dispatch({ type: 'LOADING_COMPASS_COVERAGE_REPORT_CHART_ACTION' });
            try {
                    const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/coverage-report-chart-v2`, requestObj);
                    var resData = Object.assign({ type: 'SUCCESS_COMPASS_COVERAGE_REPORT_CHART_ACTION' , data } );
                    dispatch(resData);

            } catch (error) {
                dispatch({ type: 'ERROR_COMPASS_COVERAGE_REPORT_CHART_ACTION', error });
            }
    };
}

// const FetchCompassCoverageReportChartAction = (postData) => {
//     return async function (dispatch) {
//         const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/coverage-report-chart-v2`, postData);
//         // console.log("data", data);

//         var resData = Object.assign({ type: 'SUCCESS_COMPASS_COVERAGE_REPORT_CHART_ACTION' }, data);
//         dispatch(resData);
//     };
// };

const FetchCompassExecutiveSummaryAction = (requestObj) => {
    return async function (dispatch) {
            dispatch({ type: 'LOADING_COMPASS_EXECUTIVE_SUMMARY_ACTION' });
            try {
                    const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/executive-summary-v2`, requestObj);
                    var resData = Object.assign({ type: 'SUCCESS_COMPASS_EXECUTIVE_SUMMARY_ACTION' , data } );
                    dispatch(resData);

            } catch (error) {
                dispatch({ type: 'ERROR_COMPASS_EXECUTIVE_SUMMARY_ACTION', error });
            }
    };
}

// const FetchCompassExecutiveSummaryAction = (postData) => {
//     return async function (dispatch) {
//         const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/executive-summary-v2`, postData);
//         // console.log("data", data);

//         var resData = Object.assign({ type: 'SUCCESS_COMPASS_EXECUTIVE_SUMMARY_ACTION' }, data);
//         dispatch(resData);
//     };
// };

const FetchCompassDropdownAction = (postData) => {
    return async function (dispatch) {
            dispatch({ type: 'LOADING_COMPASS_DROPDOWN_ACTION' });
            try {
                    const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/dropdown-filters`, postData);
                    var resData = Object.assign({ type: 'SUCCESS_COMPASS_DROPDOWN_ACTION' , data } );
                    dispatch(resData);

            } catch (error) {
                dispatch({ type: 'ERROR_COMPASS_DROPDOWN_ACTION', error });
            }
    };
};

const FetchCompassDropdownV2Action = (postData) => {
    return async function (dispatch) {
            dispatch({ type: 'LOADING_COMPASS_DROPDOWN_V2_ACTION' });
            try {
                    const data = await postApiCall(`${appConstants.BASE_URL}/commodity-buy-plan-compass/dropdown-filters-v2`, postData);
                    var resData = Object.assign({ type: 'SUCCESS_COMPASS_DROPDOWN_V2_ACTION' , data } );
                    dispatch(resData);

            } catch (error) {
                dispatch({ type: 'ERROR_COMPASS_DROPDOWN_V2_ACTION', error });
            }
    };
};

export {
    FetchCompassDetailAction,
    FetchCompassMainAction,
    FetchCompassDropdownAction,
    FetchCompassDropdownV2Action,
    FetchCompasskpiPageHeaderAction,
    FetchCompassSectorBuChartAction,
    FetchCompassSectorCategoryChartAction,
    FetchCompassCoverageReportChartAction,
    FetchCompassExecutiveSummaryAction
}